import { useQuery } from 'react-query';
import request from 'utils/request';
import { querySetting } from 'utils/requestGql';

export const listFaqsQuery = () => request('GET', '/faqs/index');

export const useGetListFaq = () => useQuery('helper.faq',
  () => listFaqsQuery(),
  querySetting);
